import axios from '@services/api/axios';

const api = {
  getIspringToken: () => axios.get('/cic-learn/token'),
};

export default api;
